import {
  View,
  Image,
  Text,
  Alert,
  Switch,
  ScrollView,
  TouchableOpacity,
  Modal,
  Pressable,
  Platform,
  TextInput,
} from "react-native";
import React, { useEffect, useState ,useRef } from "react";
import { SafeAreaView } from "react-native-safe-area-context";
import DraggableGridView from "react-native-drag-sort-gridview";
import * as ImagePicker from "expo-image-picker";
import {
  convertIntoEnglish,
  getCity,
  getImageURL,
  getS3URL,
  getSingleExprience,
  getUser,
  putImageInS3URL,
  updateUser,
} from "../../../../services/ProfileSettings/ProfileSettingService";
import { RootState, dispatch, useSelector } from "../../../../redux/store";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import OnBoardingIcons from "../../../../assets/Icons/OnBoardingIcons";
import FeedIcons from "../../../../assets/Icons/FeedIcons";
import SettingsIcons from "../../../../assets/Icons/SettingsIcons";
import styles from "../../styles/styles";
import editProfileStyle from "../../styles/editProfileStyle";
import PreviewModal from "../../../../modal/OnBoardingModal/PreviewModal";
import { LinearGradient } from "expo-linear-gradient";
import profileStyle from "../../styles/profileStyle";
import AsyncStorage from '@react-native-async-storage/async-storage';
import AlertNotEdit from "../../../../modal/UserProfileModals/AlertNotEdit";
import ExperienceIcons from "../../../../assets/Icons/ExperienceIcons";
import { Colors } from "../../../../globalStyles/ColorConfig";
import BackAlert from "../../../../modal/UserProfileModals/BackAlert";
import OnboardingUploadModal from "../../../../modal/OnBoardingModal/OnboardingUploadModal";
// import langdetect from 'langdetect';

interface IItem {
  id: number;
  color: string;
}
export default function EditProfile({ navigation }: { navigation: any }) {
  const [imageArrays, setimageArrays] = useState<any[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isEnabled1, setIsEnabled1] = useState(false);
  const toggleSwitch = () => setIsEnabled((previousState) => !previousState);
  const {location} = useSelector((state: RootState)=> state.user)
  const [placeholder, setPlaceholder] = useState("");
  const [alertEdit,setAlertEdit]=useState(false);
  const [alertReason,setAlertReason]=useState("");
  const [back,setBack]=useState(false)

  const [preview, setPreview] = useState(false);
  const [exprienceArray, setExprienceArray] = useState<any[]>([]);
  const [exprienceArrayId, setExprienceArrayId] = useState<any[]>([]);
  const [staticData, setStaticData] = useState<any>(null);
  const previousData=useRef();
  const handleUploadGallery = async () => {
    // const options = ;
    // setModalVisible(!modalVisible)
    let response = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      aspect: [4, 3],
      quality: 0.5,
      allowsMultipleSelection: true,
      orderedSelection: true,
      selectionLimit: 6,
    });
    if (!response.canceled) {
      // console.log(response)
      for (let j in response.assets) {
        const body = {
          fileName: Math.random().toString(36).substring(2, 12),
          contentType: response.assets?.[j]?.type || 'image/jpeg',
          fileType: "profileImage", // add user id
          fileTypeId: staticData._id,
          imageURL: response.assets?.[j]?.uri,
        };
        // console.log(body);
        const url = await uploadfunction(body);
        // console.log(url);
        setimageArrays((previmageArrays) => [...previmageArrays, url]);
        setStaticData((prev: any) => {
          return {
            ...prev,
            photos: [...prev.photos, url],
          };
        });
      }
    }

    setModalVisible(!modalVisible);
  };

  const backButtonHandle=()=>{
    
    if(previousData.current!=staticData)
   {setBack(true)
    console.log(previousData.current,"first");
    console.log(staticData)
  }
   else {
    navigation.goBack()
   }
  }

  const uploadfunction = async (body: any) => {
    const getURL = await getS3URL(body);
    const putURl = await putImageInS3URL(getURL.preSignedUrl, body);
    const uploadedURL = await getImageURL(body);
    return uploadedURL.url;
  };

async function handleSubmit() {
    const response = await updateUser(staticData);
    const jsonValue = JSON.stringify(staticData);
    await AsyncStorage.setItem('user', jsonValue);
    previousData.current=staticData
    setPreview(true);
    // getUserData();
}

  async function getUserData2() {
    const response = await getUser();
    previousData.current = response
    console.log(previousData.current)
    setStaticData(response?.data);
    setimageArrays(response?.data?.photos);
    setExprienceArrayId(response?.data?.interestedExperiences);
  }


  const displayArray = (array: any) => {
    let str = "";
    if(array.length>1)
    {
      str=str+array[0] + `+${array.length -1 }` 
    }
    else{
      str=array[0]
    }
    return str;
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getUserData2();
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const getExperience = async () => {
      let tempArray = exprienceArrayId;
      let exprience = [];
      for (let i = 0; i < tempArray?.length; i++) {
        let data = await getSingleExprience(tempArray[i].id);
        exprience.push(data);
      }
      setExprienceArray(exprience);
    };

    getExperience();
  }, [exprienceArrayId]);
  const [setPreiewData, setPreviewData] = useState<any>(null);
  const handlePreview = () => {
    setPreview(true);
  };

  return (
    <>
      <ScrollView>
        <SafeAreaView
          style={{
            backgroundColor: "white",
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {preview && (
            <PreviewModal
              isDialog={false}
              isVisible={preview}
              toggleModal={() => setPreview(false)}
              data={staticData}
            />
          )}
          <AlertNotEdit
            isVisible={alertEdit}
            toggleModal={()=>setAlertEdit(!alertEdit)}
            reason={alertReason}

          />
          <BackAlert isVisible={back} toggleModal={()=>setBack(!back)} method1={()=>{navigation.goBack()}}  />



          {/* <Modal
            animationType="slide"
            transparent={true}
            visible={modalVisible}
            onRequestClose={() => {
              Alert.alert("Modal has been closed.");
              setModalVisible(!modalVisible);
            }}
          >

            <View style={styles.centeredView}>
              <View style={styles.modalView}>
                <View style={{
                  width: '100%',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}>
                <Text
                  style={[
                    styles.modalText,
                    GlobalStyles.heading3,
                    GlobalStyles.black90,
                  ]}
                >
                  Find a photo
                </Text>
                <Pressable onPress={() => setModalVisible(!modalVisible)}>
                  <ExperienceIcons.Cross/>
                </Pressable>
                </View>
                <View style={styles.modalBoxInner}>
                  <TouchableOpacity
                    style={styles.modalBox}
                    onPress={handleUploadGallery}
                  >
                    <View style={styles.modelCircle}>
                      <SettingsIcons.UploadIcon />
                    </View>
                    <Text>Upload from gallery</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </Modal> */}
          <OnboardingUploadModal
                isVisible={modalVisible}
                toggleModal={()=>setModalVisible(!modalVisible)}
                onPress={handleUploadGallery}
            />

          {staticData != null && (
            <>
              <View style={editProfileStyle.stickTopBar}>
                <View style={editProfileStyle.backBoxMain}>
                  <View style={editProfileStyle.backBox}>
                    <TouchableOpacity onPress={() => backButtonHandle()}>
                      <FeedIcons.BackIcon />
                    </TouchableOpacity>
                    <Text
                      style={[
                        GlobalStyles.heading3,
                        {
                          marginLeft: 10,
                        },
                      ]}
                    >
                      {staticData?.firstName && staticData.firstName.length > 9
                          ? staticData.firstName.slice(0, 14) + ".."
                          : staticData.firstName}
                    </Text>
                  </View>
                  <TouchableOpacity
                    style={editProfileStyle.previewBox}
                    onPress={() => {
                      handlePreview();
                    }}
                  >
                    <SettingsIcons.PreviewEyeIcon />
                    <Text style={[GlobalStyles.bodyText]}>Preview</Text>
                  </TouchableOpacity>
                </View>
              </View>

              <ScrollView
                showsVerticalScrollIndicator={false}
                style={{
                  backgroundColor: "white",
                  width: "90%",
                  margin: "auto",
                }}
              >
                <View style={editProfileStyle.uploadBox}>
                  <Text style={editProfileStyle.uploadBoxText}>
                    My photos & videos
                  </Text>
                  {!isEnabled ? (
                    <View style={styles.uploadBoxMain}>
                      <View style={styles.innerUploadMain}>
                        {imageArrays[0] == undefined ? (
                          <TouchableOpacity
                            onPress={() => setModalVisible(true)}
                          >
                            <View style={styles.imageBox}>
                              <OnBoardingIcons.PickIcon />
                            </View>
                          </TouchableOpacity>
                        ) : (
                          <View>
                            <Image
                              style={{
                                height: 100,
                                width: 100,
                                borderRadius: 8,
                              }}
                              source={{ uri: imageArrays[0] }}
                            />
                            {imageArrays.length > 1 && (
                                <TouchableOpacity
                                    style={styles.cancleButtonBox}
                                    onPress={() => {
                                        setimageArrays(imageArrays.filter((a) => a !== imageArrays[0]));
                                        setStaticData((prev: any) => {
                                            return {
                                                ...prev,
                                                photos: imageArrays.filter((a) => a !== imageArrays[0]),
                                            };
                                        });
                                    }}
                                >
                                    <OnBoardingIcons.ReUploadIconv2 />
                                </TouchableOpacity>
                            )}
                          </View>
                        )}
                        {imageArrays[1] == undefined ? (
                          <TouchableOpacity
                            onPress={() => setModalVisible(true)}
                          >
                            <View style={styles.imageBox}>
                              <OnBoardingIcons.PickIcon />
                            </View>
                          </TouchableOpacity>
                        ) : (
                          <View>
                            <Image
                              style={{
                                height: 100,
                                width: 100,
                                borderRadius: 8,
                              }}
                              source={{ uri: imageArrays[1] }}
                            />
                            <TouchableOpacity
                              style={styles.cancleButtonBox}
                              onPress={() => {
                                setimageArrays(
                                  imageArrays.filter(
                                    (a) => a !== imageArrays[1]
                                  )
                                );
                                setStaticData((prev: any) => {
                                  return {
                                    ...prev,
                                    photos: imageArrays.filter(
                                      (a) => a !== imageArrays[1]
                                    ),
                                  };
                                });
                              }}
                            >
                              <OnBoardingIcons.ReUploadIconv2 />
                            </TouchableOpacity>
                          </View>
                        )}
                        {imageArrays[2] == undefined ? (
                          <TouchableOpacity
                            onPress={() => setModalVisible(true)}
                          >
                            <View style={styles.imageBox}>
                              <OnBoardingIcons.PickIcon />
                            </View>
                          </TouchableOpacity>
                        ) : (
                          <View>
                            <Image
                              style={{
                                height: 100,
                                width: 100,
                                borderRadius: 8,
                              }}
                              source={{ uri: imageArrays[2] }}
                            />
                            <TouchableOpacity
                              style={styles.cancleButtonBox}
                              onPress={() => {
                                setimageArrays(
                                  imageArrays.filter(
                                    (a) => a !== imageArrays[2]
                                  )
                                );
                                setStaticData((prev: any) => {
                                  return {
                                    ...prev,
                                    photos: imageArrays.filter(
                                      (a) => a !== imageArrays[2]
                                    ),
                                  };
                                });
                              }}
                            >
                              <OnBoardingIcons.ReUploadIconv2 />
                            </TouchableOpacity>
                          </View>
                        )}
                      </View>

                      <View style={styles.uploadBoxMain}>
                        <View style={styles.innerUploadMain}>
                          {imageArrays[3] == undefined ? (
                            <TouchableOpacity
                              onPress={() => setModalVisible(true)}
                            >
                              <View style={styles.imageBox}>
                                <OnBoardingIcons.PickIcon />
                              </View>
                            </TouchableOpacity>
                          ) : (
                            <View>
                              <Image
                                style={{
                                  height: 100,
                                  width: 100,
                                  borderRadius: 8,
                                }}
                                source={{ uri: imageArrays[3] }}
                              />
                              <TouchableOpacity
                                style={styles.cancleButtonBox}
                                onPress={() => {
                                  setimageArrays(
                                    imageArrays.filter(
                                      (a) => a !== imageArrays[3]
                                    )
                                  );
                                  setStaticData((prev: any) => {
                                    return {
                                      ...prev,
                                      photos: imageArrays.filter(
                                        (a) => a !== imageArrays[3]
                                      ),
                                    };
                                  });
                                }}
                              >
                                <OnBoardingIcons.ReUploadIconv2 />
                              </TouchableOpacity>
                            </View>
                          )}
                          {imageArrays[4] == undefined ? (
                            <TouchableOpacity
                              onPress={() => setModalVisible(true)}
                            >
                              <View style={styles.imageBox}>
                                <OnBoardingIcons.PickIcon />
                              </View>
                            </TouchableOpacity>
                          ) : (
                            <View>
                              <Image
                                style={{
                                  height: 100,
                                  width: 100,
                                  borderRadius: 8,
                                }}
                                source={{ uri: imageArrays[4] }}
                              />
                              <TouchableOpacity
                                style={styles.cancleButtonBox}
                                onPress={() => {
                                  setimageArrays(
                                    imageArrays.filter(
                                      (a) => a !== imageArrays[4]
                                    )
                                  );
                                  setStaticData((prev: any) => {
                                    return {
                                      ...prev,
                                      photos: imageArrays.filter(
                                        (a) => a !== imageArrays[4]
                                      ),
                                    };
                                  });
                                }}
                              >
                                <OnBoardingIcons.ReUploadIconv2 />
                              </TouchableOpacity>
                            </View>
                          )}
                          {imageArrays[5] == undefined ? (
                            <TouchableOpacity
                              onPress={() => setModalVisible(true)}
                            >
                              <View style={styles.imageBox}>
                                <OnBoardingIcons.PickIcon />
                              </View>
                            </TouchableOpacity>
                          ) : (
                            <View>
                              <Image
                                style={{
                                  height: 100,
                                  width: 100,
                                  borderRadius: 8,
                                }}
                                source={{ uri: imageArrays[5] }}
                              />
                              <TouchableOpacity
                                style={styles.cancleButtonBox}
                                onPress={() => {
                                  setimageArrays(
                                    imageArrays.filter(
                                      (a) => a !== imageArrays[5]
                                    )
                                  );
                                  setStaticData((prev: any) => {
                                    return {
                                      ...prev,
                                      photos: imageArrays.filter(
                                        (a) => a !== imageArrays[5]
                                      ),
                                    };
                                  });
                                }}
                              >
                                <OnBoardingIcons.ReUploadIconv2 />
                              </TouchableOpacity>
                            </View>
                          )}
                        </View>
                      </View>
                    </View>
                  ) : (
                    <>
                      <DraggableGridView
                        style={{
                          width: "100%",
                          zIndex: 0,
                        }}
                        contentContainerStyle={{
                          justifyContent: "space-around",
                        }}
                        itemContainerStyle={{
                          padding: 10,
                        }}
                        isEditing={isEnabled}
                        numColumns={4}
                        itemHeight={120}
                        data={imageArrays}
                        keyExtractor={(item, index) => `${index}`}
                        shouldVibrate={false}
                        onOrderChanged={(orderedData) => {
                          setimageArrays(orderedData);
                          setStaticData((prev: any) => {
                            return {
                              ...prev,
                              photos: orderedData,
                            };
                          });
                        }}
                        renderItem={({ item, index }) => {
                          return (
                            <>
                              {
                                <View key={index}>
                                  <Image
                                    style={{
                                      height: 100,
                                      width: 100,
                                      borderRadius: 8,
                                    }}
                                    source={{ uri: item }}
                                  />
                                </View>
                              }
                            </>
                          );
                        }}
                      />
                    </>
                  )}
                  <View
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Text style={editProfileStyle.holdAndDrag}>
                      Hold and drag the photo to re-order
                    </Text>

                    <Switch
                      trackColor={{
                        false: "#767577",
                        true: "rgba(192, 164, 111, 0.24)",
                      }}
                      thumbColor={
                        isEnabled ? "rgba(192, 164, 111, 1)" : "#f4f3f4"
                      }
                      ios_backgroundColor="#3e3e3e"
                      onValueChange={toggleSwitch}
                      value={isEnabled}
                    />
                  </View>
                </View>

                {/* <View style={editProfileStyle.verifyBox}> */}
                  {/* <View style={editProfileStyle.verifyBoxInner}>
                    <FeedIcons.VerifiedBadge />
                    <Text
                      style={{
                        fontFamily: "EBGaramondMedium",
                        fontSize: 18,
                        opacity: 0.7,
                        marginLeft: 10,
                      }}
                    >
                      Verify my profile
                    </Text>
                  </View> */}
                  {/* <Image source={Icons.RightArrow} /> */}
                  {/* <Icons.RightArrow /> */}
                {/* </View> */}

                <View style={editProfileStyle.uploadBox}>
                  <Text style={editProfileStyle.holdAndDrag}>About me</Text>
                  <TextInput
                    // containerStyle={styles.textareaContainer}
                    style={[
                      editProfileStyle.textArea,
                      GlobalStyles.bodyText,
                      {
                        paddingHorizontal: 10,
                        paddingVertical: 10,
                        textAlignVertical: 'top',
                      },
                    ]}
                    // onChangeText={this.onChange}
                    onChangeText={(text: any) => {
                      setStaticData((prev: any) => {
                        return {
                          ...prev,
                          bio: text,
                        };
                      });
                    }}
                    value={staticData?.bio}
                    placeholder={"write your bio"}
                    placeholderTextColor={"#c7c7c7"}
                    underlineColorAndroid={"transparent"}
                    selectionColor={Colors.black100}
                    multiline={true}
                  />
                </View>

                <View style={editProfileStyle.uploadBox}>
                  <Text style={editProfileStyle.uploadBoxText}>
                    Share luxury experience with you partner
                  </Text>

                  <View style={editProfileStyle.outerExprienceBox}>
                    {exprienceArray[0] != null ? (
                      <View style={editProfileStyle.exprienceBox}>
                        <Image
                          source={{
                            uri: exprienceArray[0].media.images[0].url,
                          }}
                          style={{
                            width: "100%",
                            height: 150,
                            borderRadius: 9,
                          }}
                        />
                        <TouchableOpacity
                          style={styles.cancleButtonBox}
                          onPress={() => {
                            navigation.navigate("edit-experience", {
                              staticData,
                              setStaticData,
                              exprienceArrayId,
                              setExprienceArrayId
                            });
                          }}
                        >
                          {/* <Image source={Icons.ReplayIcon} /> */}
                          <SettingsIcons.Replay />
                        </TouchableOpacity>
                        <Text style={editProfileStyle.exprienceText}>
                          {exprienceArray[0].title}
                        </Text>
                      </View>
                    ) : (
                      <Pressable
                        onPress={() => {
                          navigation.navigate("edit-experience" as never,{
                            staticData,
                              setStaticData,
                              exprienceArrayId,
                              setExprienceArrayId
                          });
                        }}
                        style={editProfileStyle.exprienceBox1}
                      >
                        <SettingsIcons.UploadIcon />
                      </Pressable>
                    )}
                    {exprienceArray[1] != null ? (
                      <View style={editProfileStyle.exprienceBox}>
                        <Image
                          style={{
                            width: "100%",
                            height: 150,
                            borderRadius: 9,
                          }}
                          source={{
                            uri: exprienceArray[1].media.images[0].url,
                          }}
                        />
                        <TouchableOpacity
                          style={styles.cancleButtonBox}
                          onPress={() => {
                            navigation.navigate("edit-experience",{
                              staticData,
                              setStaticData,
                              exprienceArrayId,
                              setExprienceArrayId
                            });
                          }}
                        >
                          {/* <Image source={Icons.ReplayIcon} /> */}
                          <SettingsIcons.Replay />
                        </TouchableOpacity>
                        <Text style={editProfileStyle.exprienceText}>
                          {exprienceArray[1].title}
                        </Text>
                      </View>
                    ) : (
                      <TouchableOpacity
                        onPress={() => {
                          navigation.navigate("edit-experience",{
                            staticData,
                            setStaticData,
                            exprienceArrayId,
                            setExprienceArrayId
                          });
                        }}
                      >
                        <View style={editProfileStyle.exprienceBox1}>
                          <SettingsIcons.UploadIcon />
                        </View>
                      </TouchableOpacity>
                    )}
                    {exprienceArray[2] != null ? (
                      <View style={editProfileStyle.exprienceBox}>
                        <Image
                          style={{
                            width: "100%",
                            height: 150,
                            borderRadius: 9,
                          }}
                          source={{
                            uri: exprienceArray[2].media.images[0].url,
                          }}
                        />
                        <TouchableOpacity
                          style={styles.cancleButtonBox}
                          onPress={() => {
                            navigation.navigate("edit-experience",{
                              staticData,
                              setStaticData,
                              exprienceArrayId,
                              setExprienceArrayId
                            });
                          }}
                        >
                          {/* <Image source={Icons.ReplayIcon} /> */}
                          <SettingsIcons.Replay />
                        </TouchableOpacity>
                        <Text style={editProfileStyle.exprienceText}>
                          {exprienceArray[2].title}
                        </Text>
                      </View>
                    ) : (
                      <TouchableOpacity
                        onPress={() => {
                          navigation.navigate("edit-experience",{
                            staticData,
                              setStaticData,
                              exprienceArrayId,
                              setExprienceArrayId
                          });
                        }}
                      >
                        <View style={editProfileStyle.exprienceBox1}>
                          <SettingsIcons.UploadIcon />
                        </View>
                      </TouchableOpacity>
                    )}
                  </View>
                </View>

                <View style={[editProfileStyle.uploadBox, { marginTop: 20 }]}>
                  <View style={editProfileStyle.lowerMainHead}>
                    <Text
                      style={{
                        fontFamily: "InterSemiBold",
                        fontSize: 18,
                        opacity: 0.6,
                        letterSpacing: 0.01,
                      }}
                    >
                      My vitals
                    </Text>
                  </View>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() => {
                      navigation.navigate("edit-name",{
                        staticData,
                        setStaticData,
                        setPreview
                      });
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Name
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.firstName} {staticData?.lastName}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() => {
                      navigation.navigate("edit-gender",{
                        staticData,
                        setStaticData,
                      });
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Gender
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.gender}
                    </Text>
                  </TouchableOpacity>
                 
                  <TouchableOpacity style={editProfileStyle.lowerMainHead} onPress={() => {setAlertReason("age") ; setAlertEdit(true)}}>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Age
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.age}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() => {
                      navigation.navigate("edit-height", {
                        staticData,
                        setStaticData,
                      });
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Height
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.userInfo?.height} cm
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() =>
                      navigation.navigate("body-edit", {
                        staticData,
                        setStaticData,
                      })
                    }
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Body type
                    </Text>
                    <Text style={GlobalStyles.bodyText}>
                      {staticData?.userInfo?.bodyType}
                    </Text>
                  </TouchableOpacity>
                  {
                    Platform.OS !== 'web' && (
                  <TouchableOpacity style={editProfileStyle.lowerMainHead} onPress={() => {setAlertReason("Location") ; setAlertEdit(true)}}>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Location
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {location && <> {location}</>}
                    </Text>
                  </TouchableOpacity>
                    )
                  }
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() =>
                      navigation.navigate("ethnicity", {
                        staticData,
                        setStaticData,
                      })
                    }
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Ethinicity
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.userInfo?.ethnicity}
                    </Text>
                  </TouchableOpacity>
                </View>

                <View style={[editProfileStyle.uploadBox, { marginTop: 13 }]}>
                  <View style={editProfileStyle.lowerMainHead}>
                    <Text
                      style={{
                        fontFamily: "InterSemiBold",
                        fontSize: 18,
                        opacity: 0.6,
                        letterSpacing: 0.01,
                      }}
                    >
                      My virtues
                    </Text>
                  </View>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() => {
                      navigation.navigate("edit-workplace", {
                        staticData,
                        setStaticData,
                      });
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Workspace
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.userInfo?.company}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() => {
                      navigation.navigate("edit-jobtitle", {
                        staticData,
                        setStaticData,
                      });
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Jobtitle
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.userInfo?.currentPosition}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() => {
                      navigation.navigate("edit-school", {
                        staticData,
                        setStaticData,
                      });
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      School
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.userInfo?.school}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() => {
                      navigation.navigate("edit-language", {
                        staticData,
                        setStaticData,
                      });
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Language spoken
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {displayArray(staticData?.userInfo?.languages)}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() => {
                      navigation.navigate("edit-seeking", {
                        staticData,
                        setStaticData,
                      });
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Seeking in
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.preferences?.seeking}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() => {
                      navigation.navigate("edit-relationship", {
                        staticData,
                        setStaticData,
                      });
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Relationship status
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.userInfo?.relationshipStatus}
                    </Text>
                  </TouchableOpacity>
                </View>
                <View style={[editProfileStyle.uploadBox, { marginTop: 20 }]}>
                  <View style={editProfileStyle.lowerMainHead}>
                    <Text
                      style={{
                        fontFamily: "InterSemiBold",
                        fontSize: 18,
                        opacity: 0.6,
                        letterSpacing: 0.01,
                      }}
                    >
                      My vices
                    </Text>
                  </View>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() => {
                      navigation.navigate("edit-drinking", {
                        staticData,
                        setStaticData,
                      });
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Drinking
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.userInfo?.drinker}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={editProfileStyle.lowerMainHead}
                    onPress={() => {
                      navigation.navigate("edit-smoking", {
                        staticData,
                        setStaticData,
                      });
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 15,
                        opacity: 0.4,
                        letterSpacing: 0.2,
                      }}
                    >
                      Smoking
                    </Text>
                    <Text
                      style={{
                        fontFamily: "InterRegular",
                        fontSize: 16,
                        letterSpacing: 0.2,
                      }}
                    >
                      {staticData?.userInfo?.smoker}
                    </Text>
                  </TouchableOpacity>
                </View>

                <View style={{ height: 55 }}></View>
              </ScrollView>
            </>
          )}
        </SafeAreaView>
      </ScrollView>
      {!preview && (
        <>
          <View
            style={{
              position: "absolute",
              bottom: Platform.OS === "web" ? 5 : 20,
              width: "100%",
              display: "flex",
              alignItems: "center",
              zIndex: 3,
            }}
          >
            <TouchableOpacity
              style={{
                height: 50,
                backgroundColor: "rgba(31, 57, 48, 1)",
                borderRadius: 50,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                alignContent: "center",
                marginTop: 10,
                width: Platform.OS === "web" ? "95%" : "90%",

                marginHorizontal: "auto",
              }}
              onPress={handleSubmit}
            >
              <Text style={[GlobalStyles.bodyText, { color: "white" }]}>
                Submit
              </Text>
            </TouchableOpacity>
          </View>
        </>
      )}
    </>
  );
}
